"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _components = require("../../../components");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Build an EnhancedComponent using a React component like `<List />` or
 * props like `{component: <List />}` as the basis.
 *
 * @param {ReactNode|Object} componentOrProps
 * @param {ReactNode} componentOrProps.component
 * @param {Object} componentOrProps.initialState
 * @param {Object} componentOrProps.extraActions
 * @returns {ReactNode}
 */
var buildEnhancedComponent = function (componentOrProps) {
  if (_react.default.isValidElement(componentOrProps)) {
    return _react.default.createElement(_components.EnhancedComponent, {
      component: componentOrProps
    });
  }

  return _react.default.createElement(_components.EnhancedComponent, componentOrProps);
};

var _default = buildEnhancedComponent;
exports.default = _default;